import AccordianBanner from 'components/UI/AccordianBanner';
import RichText from 'components/UI/Richtext';
import { ReactElement, useState } from 'react';
import { IComponentQuestionAndAnswerFields } from 'types/contentful';

export default function QuestionAndAnswer({
  id,
  faqGrouping,
}: IComponentQuestionAndAnswerFields): ReactElement {
  const [openIndices, setOpenIndices] = useState<Set<number>>(new Set());

  const toggleAccordion = (index: number): void => {
    setOpenIndices((prev) => {
      const updated = new Set(prev);
      if (updated.has(index)) {
        updated.delete(index);
      } else {
        updated.add(index);
      }
      return updated;
    });
  };

  if (!faqGrouping) return <></>;

  return (
    faqGrouping && (
      <div id={id} className="pb-10 md:pb-20 md:px-20 lg:px-32 ">
        <h5 className={`text-center text-primary-actual mb-8 font-light text-2xl md:text-4xl`}>
          {faqGrouping.fields?.heading}
        </h5>
        {faqGrouping.fields?.faqs.map((x, i, arr) => {
          const isLast = i === arr.length - 1;

          return (
            <div key={i} className={`border-t-2 border-highlight ${isLast ? 'border-b-2' : ''}`}>
              <AccordianBanner
                className=""
                type="FAQ"
                onClick={() => toggleAccordion(i)}
                isOpen={openIndices.has(i)}
                header={x.fields.question}
              />
              {openIndices.has(i) && (
                <div className="p-4">
                  <RichText document={x.fields.answer} classNames="text-lg text-primary-actual" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    )
  );
}
